/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Pending_KeepInputs */



/**
* | output |
* | --- |
* | "Keep current storage" |
*
* @param {Partner_Manage_Storage_Pending_KeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_pending_keep = /** @type {((inputs?: Partner_Manage_Storage_Pending_KeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Pending_KeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuellen Speicher behalten")
	return /** @type {LocalizedString} */ ("Keep current storage")
});